import "../css/BreadCrumbs.css"

const BreadCrumbs = ({ title }) => {
    return <div className="BreadCrumbs">
        <div>
            <div className="BreadCrumbs__title">
                {title}
            </div>
        </div>
    </div>
}

export default BreadCrumbs
